module.exports = {
        srcSet: __webpack_public_path__ + "static/media/section1@3x-498.7cb5849a.webp"+" 498w",
        images: [{path: __webpack_public_path__ + "static/media/section1@3x-498.7cb5849a.webp",width: 498,height: 498}],
        src: __webpack_public_path__ + "static/media/section1@3x-498.7cb5849a.webp",
        toString: function(){return __webpack_public_path__ + "static/media/section1@3x-498.7cb5849a.webp"},
        
        width: 498,
        height: 498
      }